import detailPanel from './rbata.detailpanel';

const ctaBar = {
    $ctaBar:            undefined,
    detailPanel:        undefined,
    SHOW_CTA_CLASS:     'pdp__cta-bar--show',
    cartPanelId:        'js-pdp__cart-panel-anchor',
    reccoCarouselClass: 'js-reco-carousel-wrapper',
    isCartIntersecting: true,
    observer:           undefined,
    addToCartForm:      undefined,
    reccoCarousel:      undefined,

    bindCtaObservable: () => {
        ctaBar.addToCartForm = document.querySelector(`#${ctaBar.cartPanelId}`);
        ctaBar.reccoCarousel = document.querySelector(`.${ctaBar.reccoCarouselClass}`);

        const options = {
            rootMargin: '0px',
            threshold:  [0, 1.0]
        }

        ctaBar.observer = new IntersectionObserver(ctaBar.ctaAction, options);

        if (ctaBar.addToCartForm) {
            ctaBar.observer.observe(ctaBar.addToCartForm);
        }
        if (ctaBar.reccoCarousel) {
            ctaBar.observer.observe(ctaBar.reccoCarousel);
        }
    },

    unbindCtaObservable: () => {
        if (ctaBar.observer) {
            if (ctaBar.addToCartForm) {
                ctaBar.observer.unobserve(ctaBar.addToCartForm);
            }

            if (ctaBar.reccoCarousel) {
                ctaBar.observer.unobserve(ctaBar.reccoCarousel);
            }
        }
    },

    ctaAction: (entries) => {
        for (const entry of entries) {
            if (entry.target.id === ctaBar.cartPanelId) {
                const targetAboveScreen = entry.boundingClientRect.top < 0

                ctaBar.ctaControl(targetAboveScreen);
                if (targetAboveScreen) {
                    ctaBar.isCartIntersecting = entry.isIntersecting;
                }
            }

            if (entry.target.classList.contains(ctaBar.reccoCarouselClass) && !ctaBar.isCartIntersecting) {
                ctaBar.ctaControl(
                        (!entry.isIntersecting && entry.boundingClientRect.top > 0) || (!entry.isIntersecting && !entry.boundingClientRect.top < 0)
                );
            }
        }
    },

    ctaControl(flag) {
        if (flag) {
            ctaBar.showCta()
        } else {
            ctaBar.showCta(false)
        }
    },

    showCta: (show = true) => show ? ctaBar.$ctaBar.addClass(ctaBar.SHOW_CTA_CLASS) : ctaBar.$ctaBar.removeClass(ctaBar.SHOW_CTA_CLASS),

    ctaButtonClick: () => {
        detailPanel.$pdpMainSection.on('click', '.pdp__cta-bar-button', (evt) => {
            evt.preventDefault();
            $('html, body').animate({
                scrollTop: ctaBar.detailPanel.offsetTop
            }, 2500, 'easeInOutQuart');
        });
    }
}

$(() => {
    ctaBar.$ctaBar     = $('.pdp__cta-bar');
    ctaBar.detailPanel = document.querySelector('.pdp__details-panel-wrapper');
    if (ctaBar.$ctaBar.length && !alphatauri.config.smartEditEnabled) {
        ctaBar.bindCtaObservable();
        ctaBar.ctaButtonClick();
    }
});

export default ctaBar;
